const listeners = [];

export function subscribe(listener) {
  listeners.push(listener);

  return () => {
    const index = listeners.indexOf(listener);
    if (index > -1) listeners.splice(index, 1);
  };
}

function emit(toast) {
  listeners.forEach((listener) => listener(toast));
}

export const toast = {
  success(message, duration = 3000) {
    emit({
      id: Date.now(),
      type: "success",
      message,
      duration,
    });
  },

  error(message, duration = 3000) {
    emit({
      id: Date.now(),
      type: "error",
      message,
      duration,
    });
  },

  warning(message, duration = 3000) {
    emit({
      id: Date.now(),
      type: "warning",
      message,
      duration,
    });
  },

  info(message, duration = 3000) {
    emit({
      id: Date.now(),
      type: "info",
      message,
      duration,
    });
  },
};